export const isMultipleof = (n: number, isMultipleof: number) => {
  while (n > 0) n -= isMultipleof

  if (n === 0) return true

  return false
}
